import React from "react";
import { Form, Input, DatePicker } from "antd";
import moment from "moment";
export function FormComponent({
  formItemLayout,
  getFieldDecorator,
  input,
  option,
  showOther,
  onChange,
  onSearch,
  technicalSkills,
  itemData
}) {
  const isEdit = itemData !== null;
  return (
    <Form {...formItemLayout}>
      <Form.Item label="Publication Title" className="formsteponeinout">
        {getFieldDecorator("publicationTitle", {
          initialValue: itemData ? itemData.publicationTitle : undefined,
          rules: [
            {
              required: true,
              message: "Please enter Publication Title"
            }
          ]
        })(<Input placeholder="Enter Publication Title" disabled={isEdit} />)}
      </Form.Item>

      <Form.Item
        label="Authority or Publisher (Eg:IEEE)"
        className="formsteponeinout"
      >
        {getFieldDecorator("publicationAuthority", {
          initialValue: itemData ? itemData.publicationAuthority : undefined,
          rules: [
            {
              required: true,
              message: "Please enter name of Company/Authority"
            }
          ]
        })(<Input placeholder="Enter name of Company/Authority" />)}
      </Form.Item>

      <Form.Item
        label="Publication Date ?(Approx)"
        className="formsteponeinout"
      >
        {getFieldDecorator("publicationDate", {
          initialValue: itemData
            ? moment(itemData.publicationDate, "MMMM Do YYYY")
            : undefined,
          rules: [
            {
              required: true,
              message: "Tell us the approx Publication Date"
            }
          ]
        })(<DatePicker />)}
      </Form.Item>

      <Form.Item
        label="URL of publication / ISBN(if any)"
        className="formsteponeinout"
      >
        {getFieldDecorator("publicationURL", {
          initialValue: itemData ? itemData.publicationURL : " "
        })(<Input placeholder="Enter URL of publication / ISBN" />)}
      </Form.Item>
    </Form>
  );
}
